import React from "react";

import StringInput from "../../../../../shared/components/design-system/TextInput/StringInput";
import type { TextInputProps } from "../../../../../shared/components/design-system/TextInput/base";
import "./styles.scss";

type Variant = "top-bar" | "wide";

export interface SearchInputProps {
  label: string;
  autoFocus?: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  value: string;
  variant?: Variant;
  size?: "medium" | "small";
  inputProps?: TextInputProps<string>["inputProps"];
}

export default function SearchInput({
  label,
  autoFocus,
  onChange,
  placeholder = "Search",
  value,
  variant = "wide",
  size,
  inputProps,
}: SearchInputProps) {
  return (
    <StringInput
      label={label}
      labelVariant="hidden"
      autoFocus={autoFocus}
      className={`c-search-input c-search-input--${variant}`}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
      icon="search"
      size={size}
      inputProps={inputProps}
      button={
        value
          ? {
              label: "Clear search term",
              icon: "xmark",
              onClick: () => onChange(""),
            }
          : undefined
      }
    />
  );
}
